import { createSelector } from '@reduxjs/toolkit';
import { nutritionistsAdapter } from 'features/nutritionists/state/nutritionists.slice';
import {
  nutritionistTestModalitiesSelector,
  nutritionistTestSearchTextSelector,
} from 'features/nutritionists/selectors/nutritionist-test.selector';

export const { selectAll } = nutritionistsAdapter.getSelectors(
  state => state.wnNutritionists,
);

export const nutritionistsSelector = createSelector(
  [
    selectAll,
    nutritionistTestSearchTextSelector,
    nutritionistTestModalitiesSelector,
  ],
  (_nutritionists, searchText, modalities) =>
    _nutritionists
      .map(nutritionist => ({
        ...nutritionist,
        fullName: `${nutritionist.name} ${nutritionist.lastName}`,
      }))
      // .filter(nutritionist => {
      //   const fullName = nutritionist.fullName.toLowerCase();
      //   const _searchText = searchText.toLowerCase();
      //   const specialties = nutritionist.nutritionistProfile.specialities;
      //
      //   const nameMatches = fullName.includes(_searchText);
      //   const specialtiesMatches = specialties.some(specialty =>
      //     specialty.name.toLowerCase().includes(_searchText),
      //   );
      //   return nameMatches || specialtiesMatches;
      // })
      // .filter(nutritionist => {
      //   const _modalitiesFilter = Object.keys(modalities).filter(
      //     modality => modalities[modality] === true,
      //   );
      //   const nutritionistServices = nutritionist.nutritionistProfile.services;
      //   const nutritionistAvailableModalities = [
      //     ...new Set(nutritionistServices.map(service => service.mode).flat()),
      //   ];
      //
      //   return nutritionistAvailableModalities.some(modality =>
      //     _modalitiesFilter.includes(modality),
      //   );
      // }),
);
